module.exports = __webpack_public_path__ + "static/media/formulas.2cd4e1d7.png";